import { Award, ShieldCheck, ChevronDown, ChevronUp } from "lucide-react";
import { useState } from "react";

const certs = [
  "CrowdStrike Certified SIEM Engineer (CCSE)",
  "CrowdStrike Certified Falcon Administrator (CCFA)",
  "Microsoft SC-400 — Information Protection & Compliance",
  "Microsoft SC-300 — Identity & Access Administrator",
  "Palo Alto PSE: SASE Associate",
  "Zscaler ZIA Administrator",
  "Fortinet NSE 1, 2, 3",
  "Forcepoint DLP Administrator",
  "IBM z/OS Mainframe Practitioner",
];

const courses = [
  "CrowdStrike FHT 200",
  "CrowdStrike FHT 202",
  "CrowdStrike IDP 270",
  "CrowdStrike SIEM 211",
  "CrowdStrike CLOUD 223",
  "CrowdStrike CLOUD 271",
  "Palo Alto EDU-260",
  "Palo Alto EDU-262",
];

export default function Certifications() {
  const [showCourses, setShowCourses] = useState(false);

  return (
    <section id="certifications" className="py-20 md:py-32 bg-white" data-testid="certifications-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#06B6D4]">Credentials</span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl font-bold tracking-tight text-[#111827] mt-3">
            Credentials & Recognition
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Award */}
          <div className="bg-white border border-[#E5E7EB] rounded-2xl p-6 md:p-8" data-testid="award-card">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[#06B6D4]/10 flex items-center justify-center shrink-0">
                <Award className="w-6 h-6 text-[#06B6D4]" />
              </div>
              <div>
                <h3 className="font-['Outfit'] text-lg font-bold text-[#111827]">
                  CrowdStrike APJ Partner Symposium
                </h3>
                <p className="text-[#06B6D4] font-semibold text-sm mt-1">MVP of the Year (2023–24)</p>
                <p className="text-sm text-[#6B7280] mt-2 leading-relaxed">
                  Recognized for outstanding project implementation and cybersecurity contributions across the Asia-Pacific & Japan region.
                </p>
              </div>
            </div>
          </div>

          {/* Certifications */}
          <div className="bg-white border border-[#E5E7EB] rounded-2xl p-6 md:p-8" data-testid="certs-card">
            <div className="flex items-center gap-3 mb-5">
              <ShieldCheck className="w-5 h-5 text-[#06B6D4]" />
              <h3 className="font-['Outfit'] text-lg font-bold text-[#111827]">Certifications</h3>
            </div>
            <div className="flex flex-wrap gap-2">
              {certs.map((c) => (
                <span
                  key={c}
                  className="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium bg-[#F9FAFB] text-[#111827] border border-[#E5E7EB]"
                  data-testid={`cert-badge-${c.slice(0, 15).toLowerCase().replace(/\s+/g, '-')}`}
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Professional Courses - collapsible */}
        <div className="mt-8">
          <button
            onClick={() => setShowCourses(!showCourses)}
            className="flex items-center gap-2 text-sm font-medium text-[#6B7280] hover:text-[#111827] transition-colors mx-auto"
            data-testid="courses-toggle"
          >
            Professional Courses
            {showCourses ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </button>
          {showCourses && (
            <div className="mt-4 flex flex-wrap justify-center gap-2 animate-fadeIn" data-testid="courses-list">
              {courses.map((c) => (
                <span
                  key={c}
                  className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium text-[#6B7280] bg-[#F9FAFB] border border-[#E5E7EB]"
                >
                  {c}
                </span>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
